/**
 * @fileName      state
 * @dateTime      2021/4/6 11:32:52
 * @author        Millionfor <millionfor@gmail.com>
 * @description
 */

export default {
  /**
   * 选中会话对象
   */
  selectCsSessionItem: null,
  /**
   * 当前登录的客服信息
   */
  csInfo: null,
  /**
   * 接口响应时间
   */
  sessionsItrResTime: '',
  /**
   * IM总数量计算
   */
  msgCount: 0,
  /**
   *  MT_IM 数量计算
   */
  msgMtCount: 0,
  /**
   * 最后一条消息内容
   */
  msgContent: null,
  /**
   * 是否全屏
   */
  isFs: false
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/cs/state.js